// extracted by mini-css-extract-plugin
module.exports = {"min":"SliderIndicatorsContainer_min__3uxX_","max":"SliderIndicatorsContainer_max__UIaD9"};